import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON } from 'react-leaflet';

import MapWrapper from '../../Map/MapWrapper';
import AreasLayer from '../../Map/Layers/Areas';
import AreaReportsModal from '../../AreaReportsModal/AreaReportsModal';
import withSize from '../../WithSize/WithSize';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
// import { humanizeNumber } from '../../../utils/format';

import './Areas.css';

export class AreasComponent extends Component {
  componentWillMount() {
    const {
      fetched,
      getAreas,
      layer,
      organizationId,
      getAreasAll,
      getBoundaryPolygon,
    } = this.props;
    if (!fetched) {
      getAreas(layer, organizationId);
      getAreasAll(organizationId).then(areas => {
        const boundary = areas.states.length > 2 ? 'states' : 'counties';
        getBoundaryPolygon(boundary, organizationId);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { fetched,
      getAreas,
      layer,
      organizationId,
      active,
      match: { params: { id } },
      addActive,
    } = nextProps;

    if (layer !== this.props.layer && !fetched) {
      getAreas(layer, organizationId);
    } else if (!active && fetched && id) {
      const area = nextProps[layer].find(a => a._id === id);
      if (area) {
        addActive(layer, area, true);
      }
    }
  }

  render() {
    const {
      active,
      activeColor,
      addActive,
      layer,
      layers,
      areaAll,
      states,
      counties,
      isMobile,
      // measure,
    } = this.props;

    const shapes = states.length > 2 ? states : counties;

    return (
      <div className="content-wrapper areas full">
        <AreaReportsModal
          area={active}
          type={layer}
        />
        <div className="navigation">
          <ul>
            {['Regions', 'Counties', 'Communities'].map(menu => (
              <li
                key={menu}
              >
                <ViewerPrimaryColorUserStyle domStyle={menu.toLowerCase() === layer && 'borderBottomColor'}>
                  <button
                    tabIndex="0"
                    className={`tab-toggle__tab ${menu.toLowerCase() === layer ? 'active' : ''}`}
                    onClick={() => { addActive(menu.toLowerCase(), null); }}
                  >
                    {menu}
                  </button>
                </ViewerPrimaryColorUserStyle>
              </li>
            ))}
          </ul>
        </div>
        <MapWrapper
          layers={layers}
          zoom={7}
          type="areas"
          polygons={(shapes || []).filter(area => !!area.polygon).map((area, index) => (
            <GeoJSON
              data={area.polygon}
              key={`${layer}${index}`}
              style={{
                color: activeColor,
                weight: 0,
                fillOpacity: 0,
              }}
            />),
          )}
          ignoreMap={isMobile}
          mapChildren={[(
            <div key="areasLayer">
              {
                Object.keys(areaAll).length > 0 &&
                <AreasLayer
                  activeColor={activeColor}
                  layer={layer}
                  areas={areaAll}
                  handleClick={addActive}
                  useEDCPopup
                />
              }
            </div>
          )]}
        />
      </div>
    );
  }
}

AreasComponent.propTypes = {
  active: PropTypes.object,
  activeColor: PropTypes.string,
  addActive: PropTypes.func.isRequired,
  getAreas: PropTypes.func,
  getAreasAll: PropTypes.func,
  getBoundaryPolygon: PropTypes.func,
  fetched: PropTypes.bool,
  layer: PropTypes.string.isRequired,
  layers: PropTypes.object,
  organizationId: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      subTab: PropTypes.string,
    }),
  }),
  states: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  counties: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      geo: PropTypes.object,
    }),
  ).isRequired,
  // measure: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  areaAll: PropTypes.object,
};

export default withSize(AreasComponent);



// WEBPACK FOOTER //
// ./src/components/Areas/AreasWrapper/AreasEDCMap.js